import { render, staticRenderFns } from "./PrimaryNavigationMenuItem.vue?vue&type=template&id=abf74d1e&scoped=true"
import script from "./PrimaryNavigationMenuItem.vue?vue&type=script&lang=js"
export * from "./PrimaryNavigationMenuItem.vue?vue&type=script&lang=js"
import style0 from "./PrimaryNavigationMenuItem.vue?vue&type=style&index=0&id=abf74d1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf74d1e",
  null
  
)

export default component.exports